var _rect, _path, _path2, _path3, _path4, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 37,
    height: 37,
    rx: 3.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 17.5C17.7761 17.5 18 17.7239 18 18V24C18 24.2761 17.7761 24.5 17.5 24.5C17.2239 24.5 17 24.2761 17 24V18C17 17.7239 17.2239 17.5 17.5 17.5Z",
    fill: "#D00026"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 17.5C20.2761 17.5 20.5 17.7239 20.5 18V24C20.5 24.2761 20.2761 24.5 20 24.5C19.7239 24.5 19.5 24.2761 19.5 24V18C19.5 17.7239 19.7239 17.5 20 17.5Z",
    fill: "#D00026"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 18C23 17.7239 22.7761 17.5 22.5 17.5C22.2239 17.5 22 17.7239 22 18V24C22 24.2761 22.2239 24.5 22.5 24.5C22.7761 24.5 23 24.2761 23 24V18Z",
    fill: "#D00026"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.5 15C26.5 15.5523 26.0523 16 25.5 16H25V25C25 26.1046 24.1046 27 23 27H17C15.8954 27 15 26.1046 15 25V16H14.5C13.9477 16 13.5 15.5523 13.5 15V14C13.5 13.4477 13.9477 13 14.5 13H18C18 12.4477 18.4477 12 19 12H21C21.5523 12 22 12.4477 22 13H25.5C26.0523 13 26.5 13.4477 26.5 14V15ZM16.118 16L16 16.059V25C16 25.5523 16.4477 26 17 26H23C23.5523 26 24 25.5523 24 25V16.059L23.882 16H16.118ZM14.5 15V14H25.5V15H14.5Z",
    fill: "#D00026"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.5,
    y: 1.5,
    width: 37,
    height: 37,
    rx: 3.5,
    stroke: "#D00026"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBorder);
export default __webpack_public_path__ + "static/media/deleteBorder.4a775ce7a5ad8a3b52084a3cd7ce6f15.svg";
export { ForwardRef as ReactComponent };